<template>
<div v-if="data.type == 'success' || data.type == 'Successful'" :class="data.type == 'success' || data.type == 'Successful'   ? 'active' : ''" id="pay-success" ref="success" class="opt-content-wrapper  pay-pane active p-4">
    <div class="text-center">
        <i class="title-icon success"></i>
    </div>

    <h3 class="text-center">Payment Successful</h3>

    <p class="mb-4"> {{ data.message || 'Congratulations your payment was successfully completed' }}.</p>

    <div class="modal-body">
        <!-- <form class="form" action="https://onechapp.me/#" method=""> -->
        <div class="row m-0">
            <div class="col-12 px-0">
                <div class="form-group mb-0">
                    <button type="submit" class="btn app-bg-color"  @click.prevent="continueToMerchant">Back to merchant</button>
                </div>
            </div>
        </div>
        <!-- </form> -->
    </div>
</div>

<div v-else-if="data.type == 'error' ||  data.type == 'failed'  ||  data.type == 'Failed'" id="pay-failed" ref="failed" :class="data.type == 'Failed' || data.type == 'error' ? 'active' : ''" class="opt-content-wrapper pay-pane active p-4">

    <div class="text-center">
        <i class="title-icon error"></i>
    </div>

    <h3 class="text-center">Payment Failed</h3>

    <p class="mb-4">Opps... your payment has failed to complete.</p>

    <div class="modal-body">
        <!-- <form class="form" action="https://onechapp.me/#" method=""> -->
        <div class="row m-0">
            <div class="col-12 px-0">
                <div v-if="data.failedFromStart == 'false'  || !data.failedFromStart" class="form-group text-center mb-2 mt-3">
                    <button type="button" class="btn app-bg-color"  @click.prevent="tryAgain"> Try Again</button>
                </div>

                <div class="form-group text-center mb-0 mt-4">
                    <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="text-tiny" @click.prevent="continueToMerchant"> &larr; Back to merchant</a>
                </div>
            </div>
        </div>
        <!-- </form> -->
    </div>
</div>

<div v-else-if="data.type == 'warning'" id="pay-warning" ref="warning" :class="data.type == 'warning'  || data.type == 'Warning' ? 'active' : ''" class="opt-content-wrapper pay-pane active p-4">

    <div class="text-center">
        <i class="title-icon warning"></i>
    </div>

    <h3 class="text-center">{{ data.heading }}</h3>

    <p class="mb-4">{{ data.message }}</p>

    <div class="modal-body">
        <div class="row m-0">
            <div class="col-12 px-0">
                <div v-if="data.failedFromStart == 'false'  || !data.failedFromStart" class="form-group text-center mb-2 mt-3">
                    <button type="button" class="btn app-bg-color"  @click.prevent="tryAgain"> Try Again</button>
                </div>

                <div class="form-group text-center mb-0 mt-4">
                    <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="text-tiny" @click.prevent="continueToMerchant"> &larr; Back to merchant</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-else id="pay-warning" ref="warning" :class="data.type == 'warning' ? 'active' : ''" class="opt-content-wrapper pay-pane active p-4">

    <div class="text-center">
        <i class="title-icon warning"></i>
    </div>

    <h3 class="text-center">Payment Canceled</h3>

    <p class="mb-4">Oops... your payment was canceled before completion or must have been completed.</p>

    <div class="modal-body">
        <!-- <form class="form" action="" method=""> -->
        <div class="row m-0">
            <div class="col-12 px-0">
                <div v-if="data.failedFromStart == 'false'  || !data.failedFromStart" class="form-group text-center mb-2 mt-3">
                    <button type="button" class="btn app-bg-color"  @click.prevent="tryAgain"> Try Again</button>
                </div>

                <div class="form-group text-center mb-0 mt-4">
                    <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="text-tiny" @click.prevent="continueToMerchant"> &larr; Back to merchant</a>
                </div>
            </div>
        </div>
        <!-- </form> -->
    </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'status',
    props: ['data', 'appColor', 'button_color'],
    created() {
        // var res = JSON.parse(window.raw) //JSON.parse(localStorage.raw);

        // Try the auto close here
        console.log(this.button_color);
        this.$emit('handleCss','');
        
    },
    methods: {
        tryAgain() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`; 
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.loading = false;
            this.$parent.changeComponent('CardPayment');
            // this.$router.push('popup');
            console.log("Clicked Try again")
        },

        continueToMerchant() {
            if (window.raw) {
                var res = JSON.parse(window.raw);
                delete res.data.client_info;
                delete res.data.paymentoptions;
                this.$parent.continueToMerchant({
                    message: res.message,
                    status: res.status,
                    data: res.data,
                });
            }
        },
    }
}
</script>
